var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 12,
    viewBox: "0 0 3 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50023 11.9995C0.676419 11.9995 -0.0206556 11.3236 0.000467857 10.4998C-0.0206556 9.67595 0.676419 9 1.50023 9C2.30293 9 3 9.67595 3 10.4998C3 11.3236 2.30293 11.9995 1.50023 11.9995Z",
    fill: "#171717",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000467857 1.49977C-0.0206556 2.32358 0.676419 2.99953 1.50023 2.99953C2.30293 2.99953 3 2.32358 3 1.49977C3 0.675951 2.30293 0 1.50023 0C0.676419 0 -0.0206556 0.675951 0.000467857 1.49977Z",
    fill: "#171717",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/dot.91b8407264aa2e0208cc08df876f10cc.svg";
export { ForwardRef as ReactComponent };